import React, { useEffect } from "react";
import { useLoginContext } from "context/login-context";
import { gerarTokenZendesk, gerarZendeskRedirectUrl, verificaLoginZendesk } from "services/zendesk/zendesk-service";
import { createTokenZendesk } from "utils/login";
import carregarMenu from "services/menu-service/menu-service";
import { verificaParametroDaUrl } from "utils/verify-url-params";
import { aceitarTermosDeUso, verificarAceiteTermosDeUso } from "services/login/termo-de-uso/termo-de-uso";
import autenticar from "services/autenticacao-service/autenticacao-service";
import { errorMap, IErrorMessageLogin } from "models/login";
import validateRecaptcha from "services/login/recaptcha/recaptcha-service";

export const useLoginHook = () => {
  const {
    checkboxTerms,
    setCanCheckLogin,
    setIsLoading,
    setRedirectURL,
    setShowTermsUse,
    showTermsUse,
    setErrorMessage,
    redirectToLogin,
  } = useLoginContext();

  const realizarRedirect = async () => {
    try {
      await createTokenZendesk();
      if (verificaLoginZendesk()) {
        const tokenZendesk = await gerarTokenZendesk();
        const zendeskRedirectUrl = gerarZendeskRedirectUrl(tokenZendesk);
        setRedirectURL(zendeskRedirectUrl);
      } else {
        const redirectUrlMenu = await carregarMenu();
        const redirectUrlParametro = verificaParametroDaUrl('redirectUrl');
        setRedirectURL(
          redirectUrlParametro || redirectUrlMenu,
        );
      }
    } catch {
      console.log('Erro ao gerar token no login');
      setErrorMessage(IErrorMessageLogin.ERRO_SERVICO);
    } finally {
      setCanCheckLogin(true);
    }
  }

  async function validate(event, email, password, token) {
    if (email && password) {
      setIsLoading(true);
      event.preventDefault();
      localStorage.clear();
      try {
        await autenticar(email, password);
        await validateRecaptcha(token);
        if (!checkboxTerms.showCheckbox) {
          const { termoAceito } = await verificarAceiteTermosDeUso();
          if (termoAceito) {
            await realizarRedirect();
          } else {
            setShowTermsUse(true);
            setIsLoading(false);
          }
        } else if (checkboxTerms.showCheckbox && checkboxTerms.isChecked) {
          await aceitarTermosDeUso();
          await realizarRedirect();
        }
      } catch (err) {
        localStorage.clear();
        setIsLoading(false);
        const apiError = err?.data?.erro ?? err;
        setErrorMessage(errorMap[apiError] ?? IErrorMessageLogin.ERRO_SERVICO);
      } finally {
        localStorage.setItem('canOpenZendesk', 'true');
      }
    }
  }
  
  const handleBackNavigation = (event) => {
    if (showTermsUse && !checkboxTerms.isChecked) {
      redirectToLogin(event);
    } else {
      window.history.pushState(null, "", window.location.pathname);
    }
  };

  useEffect(() => {
    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener('popstate', handleBackNavigation);

    return () => {
      window.removeEventListener('popstate', handleBackNavigation);
    };
  }, [window.history]);

  return {
    realizarRedirect,
    validate,
  };
};

